import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import {on, Options} from "../utils/decorators";
import {getParams} from "../utils/get-params";

@Options({
    template: false,
    ui: {
        selectFilter: "[data-js-ui=select-filter]",
        filterForm: "[data-js-ui=filter-form]",
    }
})
export default class SeasonTicketsFilterView extends Marionette.View<Backbone.Model>{

    @on("change @ui.selectFilter")
    onSelectFilterChange(e) {
        this.wantsSubmitForm();
    }

    wantsSubmitForm() {
        this.ui.filterForm.submit();
    }
}



// WEBPACK FOOTER //
// ./@modules/views/season-tickets-filter-view.ts